// extracted by mini-css-extract-plugin
module.exports = {"container":"Subcontent_container__3yZzo","withSubnavigation":"Subcontent_withSubnavigation__9b6kN"};